import React from 'react';
import { useCategory } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { SportWorld } from '../components/SportWorld';
import { HeaderGap } from '../components/HeaderGap/HeaderGap.styles';

export default function Stod2SportScene() {
	const { category } = useCategory(14431, 0);

	if (!category) return null;

	return (
		<HeaderGap>
			<SportWorld
				title={category.title}
				color={category.color}
				channelIds={['Stod2Sport_HD', 'Stod2Sport2_HD', 'Stod2Sport3_HD', 'Stod2Sport4_HD', 'Stod2Sport5_HD', 'Stod2Sport6_HD', 'PepsiMax_1', 'PepsiMax_2', 'PepsiMax_3', 'PepsiMax_4']}
				categoryId={category.id}
			/>
		</HeaderGap>
	);
}
